module.exports = __webpack_public_path__ + "zilla-slab-latin-300italic.39692695ad5ff25bcbe0e8a4b3fb7826.woff";